//--------------------------------------------------------------------//
//******************** AgentsService *********************************//
//--------------------------------------------------------------------//
// API communication layer for core agent CRUD operations.
// Skill and schedule management live in their own per-tab services:
// AgentSkillsService (agent-skills/) and AgentSchedulingService (agent-scheduling/).
import { GUDHUB_SETTINGS } from '../../config.js';
import { getAuthData, request } from './agents.request.js';
require('../../core/localizationService/localizationService.js');

angular.module('agentsTableModule', ['localizationModule'])

    .service('AgentsService', [function () {
        // Fetches all agents belonging to the authenticated user.
        this.getList = async function () {
            const authData = await getAuthData();
            const url = `${GUDHUB_SETTINGS.agents_server_url}/list?access_token=${encodeURIComponent(authData.token)}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });

            return response.json();
        };

        // Creates a new agent with the given name and API key.
        this.create = async function (agentData) {
            const authData = await getAuthData();

            return request('/create', { ...agentData, creator_user_id: authData.user_id });
        };

        // Updates agent properties (name, api_key, description, etc.).
        this.update = function (agentData) {
            return request('/update', agentData);
        };

        // Deletes an agent by its ID.
        this.delete = function (agentData) {
            return request('/delete', agentData);
        };

        // Calculates input width in ch units based on title length for auto-sizing inputs.
        this.getTitleWidth = function (title) {
            const length = title ? title.length : 10;

            return length + 1 + 'ch';
        };
    }]);
